import type { ApiProblemDetails } from "Infrastructure/Api/Api";

const hasErrorKey = (error: unknown, key: string): boolean => {
  if (typeof error !== "object" || error === null || !("data" in error)) {
    return false;
  }
  const errorData = (error as { data?: ApiProblemDetails }).data;
  return Boolean(errorData?.errors?.[key]);
};

/** The per-author 24h publishing quota (StoryErrors.PostLimitExceeded). */
export const isStoryPostLimitError = (error: unknown): boolean =>
  hasErrorKey(error, "storyPostLimitExceeded");

/** The story already has an unexpired publication (StoryErrors.AlreadyLive). */
export const isStoryAlreadyLiveError = (error: unknown): boolean =>
  hasErrorKey(error, "storyAlreadyLive");

/** Nothing live to take down any more — it expired or was taken down elsewhere (StoryErrors.NotLive). */
export const isStoryNotLiveError = (error: unknown): boolean =>
  hasErrorKey(error, "storyNotLive");

/** Content is frozen while the story is live (StoryErrors.LockedWhileLive). */
export const isStoryLockedWhileLiveError = (error: unknown): boolean =>
  hasErrorKey(error, "storyLockedWhileLive");
